import React from 'react';
import { TIconProps } from 'pages/ExperienceCanvas/assets/types';

function PendingStatusIcon({ fill = '#E6E7EB', className = '', ariaHidden = true }: TIconProps) {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={ariaHidden}
      focusable={false}
    >
      <path
        d="M8 1.33334C11.6819 1.33334 14.6667 4.3181 14.6667 8C14.6667 11.6819 11.6819 14.6667 8 14.6667C4.3181 14.6667 1.33333 11.6819 1.33333 8C1.33333 4.3181 4.3181 1.33334 8 1.33334ZM8 12.3333C10.3932 12.3333 12.3333 10.3932 12.3333 8C12.3333 5.60677 10.3932 3.66667 8 3.66667C5.60677 3.66667 3.66667 5.60677 3.66667 8C3.66667 10.3932 5.60677 12.3333 8 12.3333Z"
        fill={fill}
      />
    </svg>
  );
}

export default PendingStatusIcon;
